export default __webpack_public_path__ + "static/avatar_memoji-69102db2398e40357db9402bf7e02b17.webp";